import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header-row" }
const _hoisted_2 = { class: "h3 dashboard__title" }
const _hoisted_3 = {
  key: 0,
  class: "deferal-wrapper dashboard__title"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/credit.svg",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "deferal-content" }
const _hoisted_6 = { class: "credit-limit-text" }
const _hoisted_7 = { class: "credit-limit-value" }
const _hoisted_8 = {
  class: "dashboard__tabs",
  "data-version": "2"
}
const _hoisted_9 = { class: "dashboard__tabs-item-group" }
const _hoisted_10 = { class: "top" }
const _hoisted_11 = ["data-inc"]
const _hoisted_12 = { class: "num" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = {
  class: "no-circle-number",
  "data-version": "2"
}
const _hoisted_15 = { class: "num" }
const _hoisted_16 = { class: "custom-icon" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "top" }
const _hoisted_20 = ["data-inc"]
const _hoisted_21 = { class: "num" }
const _hoisted_22 = { class: "custom-icon" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "top" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, null, -1)
const _hoisted_27 = ["data-inc"]
const _hoisted_28 = { class: "num" }
const _hoisted_29 = { class: "c-text-weight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createVNode(_component_i18n_t, { keypath: "dashboard.myOrders" })
      ]),
      (_ctx.companyFinancialDto?.default_order_flow?.on_credit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_i18n_t, { keypath: "cart.creditLimit" })
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("b", null, "€ " + _toDisplayString(_ctx.creditRemaining), 1),
                _createTextVNode(" / € " + _toDisplayString(_ctx.creditLimit), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["dashboard__tabs-item dashboard__tabs-item--white", {
                    'is-active':
                        _ctx.orderStatusEnum[_ctx.activeItem] === _ctx.orderStatusEnum?.to_approve,
                }])
        }, [
          _createVNode(_component_router_link, {
            to: {
                        path: `/auth/my-carconnex/my-orders/${_ctx.ordersStatus?.to_approve}`,
                    },
            class: "dashboard__tabs-link c-link-height"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("strong", {
                  "data-version": "2",
                  "data-inc": 
                                _ctx.orderDetails?.to_approve?.orders_action_required_counter
                            ,
                  class: _normalizeClass({
                                'no-circle-number':
                                    _ctx.orderDetails?.to_approve
                                        ?.orders_action_required_counter === undefined ||
                                    _ctx.orderDetails?.to_approve
                                        .orders_action_required_counter === 0,
                            })
                }, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.to_approve.title" }),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.orderDetails?.to_approve?.orders_counter), 1)
                ], 10, _hoisted_11)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["dashboard__tabs-item dashboard__tabs-item--white", {
                    'is-active': _ctx.orderStatusEnum[_ctx.activeItem] === _ctx.orderStatusEnum.on_order,
                }])
        }, [
          _createVNode(_component_router_link, {
            to: {
                        path: `/auth/my-carconnex/my-orders/${_ctx.ordersStatus.on_order}`,
                    },
            class: "dashboard__tabs-link c-link-height"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("strong", _hoisted_14, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.on_order.title" }),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.orderDetails?.on_order?.orders_counter), 1)
                ]),
                _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_16, _hoisted_18)), [
                  [_directive_tippy, {
                                content: _ctx.noAvailableForTransportText,
                                placement: 'top',
                                interactive: true,
                                hideOnClick: true,
                            }]
                ])
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsInfo, (tab, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["dashboard__tabs-item dashboard__tabs-item--white", {
                        'is-active': _ctx.orderStatusEnum[_ctx.activeItem] === tab?.orderStatus,
                    }])
          }, [
            _createVNode(_component_router_link, {
              to: {
                            path: `/auth/my-carconnex/my-orders/${tab?.path}`,
                        },
              class: "dashboard__tabs-link c-link-height"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("strong", {
                    "data-version": "2",
                    "data-inc": _ctx.getValue(tab, true),
                    class: _normalizeClass({
                                    'no-circle-number':
                                        _ctx.getValue(tab, true) === undefined ||
                                        _ctx.getValue(tab, true) === 0,
                                })
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.i18n.t(tab?.title)) + " ", 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getValue(tab)), 1)
                  ], 10, _hoisted_20),
                  _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_22, _hoisted_24)), [
                    [_directive_tippy, {
                                    content:
                                        tab.orderStatus === _ctx.orderStatusEnum.to_pay
                                            ? _ctx.i18n.t('myOrders.availableForTransport')
                                            : _ctx.i18n.t('myOrders.noInfo'),
                                    placement: 'top',
                                    interactive: true,
                                }]
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(["dashboard__tabs-item dashboard__tabs-item--white", {
                    'is-active':
                        _ctx.orderStatusEnum[_ctx.activeItem] ===
                        _ctx.orderStatusEnum.processing_documents,
                }])
        }, [
          _createVNode(_component_router_link, {
            to: {
                        path: `/auth/my-carconnex/my-orders/${_ctx.ordersStatus.processing_documents}`,
                    },
            class: "dashboard__tabs-link c-link-height"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("strong", {
                  "data-version": "2",
                  "data-inc": 
                                _ctx.orderDetails?.processing_documents
                                    ?.orders_action_required_counter
                            ,
                  class: _normalizeClass({
                                'no-circle-number':
                                    _ctx.orderDetails?.processing_documents
                                        ?.orders_action_required_counter === undefined ||
                                    _ctx.orderDetails?.processing_documents
                                        ?.orders_action_required_counter === 0,
                            })
                }, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.processing_documents.title" }),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.orderDetails?.processing_documents?.orders_counter), 1)
                ], 10, _hoisted_27)
              ])
            ]),
            _: 1
          }, 8, ["to"])
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["dashboard__tabs-item dashboard__tabs-item--separate dashboard__tabs-item--white dashboard__tabs-item--ml", {
                'is-active': _ctx.orderStatusEnum[_ctx.activeItem] === _ctx.orderStatusEnum?.completed,
            }])
      }, [
        _createVNode(_component_router_link, {
          class: "dashboard__tabs-link c-link-height",
          to: {
                    path: `/auth/my-carconnex/my-orders/${_ctx.ordersStatus?.completed}`,
                }
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, [
              _createVNode(_component_i18n_t, { keypath: "myOrders.completed.title" })
            ]),
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.orderDetails?.completed?.orders_counter), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ], 2)
    ])
  ], 64))
}